module.exports = __webpack_public_path__ + "static/media/package-6.254ca818.jpg";